import './js/_global'
import './js/_functions'

// Elements.
import './js/elements/_navbar.js'

// Feeds.
import './js/feeds/_faq.js'

// Pages.
import './js/pages/_faq.js'; import './js/pages/_glossary.js'

// Parts.
import './js/parts/_notification.js'

// Headers.
import './js/headers/achievement.js'; import './js/headers/achievements.js'; import './js/headers/posts.js'; import './js/headers/services.js'

// Shortcodes.
import './js/shortcodes/_contact-form.js'

// Blocks.
import './js/blocks/_achievements.js'; import './js/blocks/_reviews.js'; import './js/blocks/_services.js'

// Singles.
import './js/singles/achievement.js'; import './js/singles/service.js'
